module.exports = __webpack_public_path__ + "img/Seliro.67c254bd.png";